import formatDate from 'helpers/dateTimeFormatter'
import { numberColumn } from 'components/DataTable'

export default t => ([
	{
		Header: t('statistic_section.strings.date_time'),
		accessor: 'dateTime',
		Cell: ({ value }) => formatDate(value, 'DD.MM.YYYY HH:mm'),
		width: 150
	}, {
		Header: t('statistic_section.strings.bill_number'),
		accessor: 'billNumber'
	}, {
		Header: t('category_section.fields.description'),
		accessor: 'description',
		width: 250
	}, {
		Header: t('cash_book_section.strings.debit'),
		accessor: 'should',
		...numberColumn()
	}, {
		Header: t('cash_book_section.strings.own'),
		accessor: 'have',
		...numberColumn()
	}, {
		Header: t('user_section.fields.balance'),
		accessor: 'balance',
		...numberColumn()
	}, {
		Header: t('common.strings.vat'),
		accessor: 'taxCode',
		Cell: ({ value }) => {
			switch (value) {
				case 'reduced':
					return t('cash_book_section.strings.mwst_reduced')
				case 'normal':
					return t('cash_book_section.strings.mwst_normal')
				case 'special':
					return t('cash_book_section.strings.mwst_special')
				case 'free' :
					return t('cash_book_section.strings.mwst_free')
				default:
					return value
			}
		}
	}, {
		Header: t('cash_book_section.strings.account'),
		accessor: 'shouldAccount',
		Cell: ({ value }) => (!value || isNaN(value)) ? null : Number(value).toFixed(0)
	}, {
		Header: t('cash_book_section.strings.account_offset'),
		accessor: 'haveAccount',
		Cell: ({ value }) => (!value || isNaN(value)) ? null : Number(value).toFixed(0)
	}
])
